import { createColumnHelper } from '@tanstack/react-table';
import { ResourceBlock } from '@mews-commander/data-access';
import { Link, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { DateTimeCell, ResourceName } from '../../../../common';
import { ResourceType } from '../components';

const columnHelper = createColumnHelper<ResourceBlock>();

interface UseColumsProps {
    handleResourceBlockClick: (data: ResourceBlock) => void;
}

export const useColumns = ({ handleResourceBlockClick }: UseColumsProps) => [
    columnHelper.accessor('name', {
        header: () => lt('Name'),
        cell: (props) => {
            const name = props.getValue();
            return name ? (
                <Stack vertical fill>
                    <Link onClick={() => handleResourceBlockClick(props.row.original)} inherit>
                        {name}
                    </Link>
                </Stack>
            ) : null;
        },
    }),
    columnHelper.accessor('type', {
        header: () => lt('Type'),
        cell: (props) => (
            <Stack vertical fill>
                <ResourceType type={props.getValue()} />
            </Stack>
        ),
    }),
    columnHelper.accessor('assignedResourceId', {
        header: () => lt('Space'),
        cell: (props) => (
            <Stack vertical fill>
                <ResourceName resourceId={props.getValue()} />
            </Stack>
        ),
    }),
    columnHelper.accessor('startUtc', {
        header: () => lt('Start'),
        cell: (props) => (
            <Stack vertical fill>
                <DateTimeCell utcString={props.getValue()} />
            </Stack>
        ),
    }),
    columnHelper.accessor('endUtc', {
        header: () => lt('End'),
        cell: (props) => (
            <Stack vertical fill>
                <DateTimeCell utcString={props.getValue()} />
            </Stack>
        ),
    }),
    columnHelper.accessor('notes', {
        header: () => lt('Notes'),
        cell: (props) => props.getValue(),
    }),
];
